// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H14V10.2792L15 9.94591L22 12.2792V22H16V16H14V22H2V2ZM8 12.2792L12 10.9459V4H4V20H8V12.2792Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-11-filled')
export default class City11FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-11-filled',
    }
  }
}
